import ChangePasswordForm from 'components/change-password-form/ChangePasswordForm'

const ChangePasswordPage = () => {
  return (
    <div>
      <ChangePasswordForm />
    </div>
  )
}

export default ChangePasswordPage
